import React from "react";
import { Box, Typography } from "@mui/material";
import expert from "../../assets/expert_new.png"; //
import Image from "next/image";

interface MainBannerProps {
  selected?: boolean;
}

const MainBanner: React.FC<MainBannerProps> = ({ selected }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        color: "white",
        margin: "auto",
        marginTop: { xs: "0.5rem", sm: "1rem" },
        padding: {
          xs: "0 0.25rem",
          sm: "0",
        },
      }}
    >
      <Box
        sx={{
          flex: 0.7,
          margin: "auto",
          width: "100%",
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.25rem", sm: "1.85rem", md: "2.15rem" },
            letterSpacing: "0.02em",
            marginBottom: { xs: "0.75rem", sm: "1rem" },
            color: "#fff",
            marginTop: { xs: "0.5rem", sm: "1rem" },
            textAlign: "center",
            lineHeight: 1.35,
            textShadow: "0 2px 20px rgba(0,0,0,0.2)",
          }}
        >
          {selected ? (
            <>
              Be your own boss - join India&apos;s leading at-home beauty
              platform
            </>
          ) : (
            "अपने खुद के बॉस बनें - भारत की अग्रणी होम ब्यूटी प्लेटफॉर्म से जुड़ें"
          )}
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          mt: { xs: 1, sm: 2 },
        }}
      >
        <Image
          src={expert}
          alt="SalonTym professional"
          height={1000}
          width={1000}
          style={{
            maxWidth: "100%",
            width: "100%",
            height: "auto",
            objectFit: "scale-down",
            borderRadius: "12px",
          }}
          priority
        />
      </Box>
    </Box>
  );
};

export default MainBanner;
